import { createAction } from '@reduxjs/toolkit';

export const ADD_STREAM_ACTION_TYPE = 'saga/addStream';
export const addStreamAction = createAction(ADD_STREAM_ACTION_TYPE);
